import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { Check, Monitor, Moon, Sun } from 'lucide-react';

import { useApp } from '@/presentation/hooks/use-app.js';

type ThemeMode = 'light' | 'dark' | 'system';

const MODE_OPTIONS: { value: ThemeMode; icon: React.ElementType; labelKey: string }[] = [
    { value: 'light', icon: Sun, labelKey: 'theme.light' },
    { value: 'dark', icon: Moon, labelKey: 'theme.dark' },
    { value: 'system', icon: Monitor, labelKey: 'theme.system' }
];

export function ThemeModeSelector() {
    const { translate, useThemeStore } = useApp();
    const darkMode = useThemeStore((s) => s.theme.darkMode);
    const setDarkMode = useThemeStore((s) => s.setDarkMode);

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ px: 2, py: 0.75, display: 'block', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                {translate('theme.appearance')}
            </Typography>
            {MODE_OPTIONS.map((option) => {
                const Icon = option.icon;
                const selected = darkMode === option.value;
                return (
                    <MenuItem key={option.value} onClick={() => setDarkMode(option.value)} selected={selected} sx={{ py: 0.75 }}>
                        <ListItemIcon sx={{ minWidth: 32 }}>
                            <Icon size={16} />
                        </ListItemIcon>
                        <ListItemText primary={translate(option.labelKey)} slotProps={{ primary: { variant: 'body2' } }} />
                        {selected && (
                            <ListItemIcon sx={{ minWidth: 24, justifyContent: 'flex-end' }}>
                                <Check size={14} />
                            </ListItemIcon>
                        )}
                    </MenuItem>
                );
            })}
        </Box>
    );
}
